import { Tooltip } from "antd";
import { memo } from "react";
import { Customer } from "types/customer";
import { $url } from "utils/url";

type Contact = { name: string; avatar: string; phone: string };

const initials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(-2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

const getContacts = (customer: Customer): Contact[] =>
  [
    { name: customer.contactName1, avatar: customer.contactAvatar1, phone: customer.contactPhone1 },
    { name: customer.contactName2, avatar: customer.contactAvatar2, phone: customer.contactPhone2 },
  ]
    .map((contact) => ({
      name: (contact.name || "").trim(),
      avatar: contact.avatar || "",
      phone: (contact.phone || "").trim(),
    }))
    .filter((contact) => contact.name || contact.avatar || contact.phone);

// Hiển thị tối đa 2 người liên hệ: ảnh + tên (hover xem SĐT)
export const ContactsCell = memo(({ customer }: { customer: Customer }) => {
  const contacts = getContacts(customer);

  if (!contacts.length) {
    return <span className="customerContacts__empty">--</span>;
  }

  return (
    <div className="customerContacts">
      {contacts.map((contact, index) => (
        <Tooltip key={index} title={contact.phone || undefined}>
          <div className="customerContacts__item">
            {contact.avatar ? (
              <img className="customerContacts__avatar" src={$url(contact.avatar)} alt="" />
            ) : (
              <span className="customerContacts__avatar customerContacts__avatar--text">
                {initials(contact.name) || "?"}
              </span>
            )}
            <span className="customerContacts__name">{contact.name || "--"}</span>
          </div>
        </Tooltip>
      ))}
    </div>
  );
});
